import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import * as sashBannerStyles from "./SashBanner.module.scss"
import FrameModal from "../frames/frameModal"
import { buildFramePayload } from "../frames/framePayload"

const SashBanner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        filter: {
          fileAbsolutePath: { regex: "/content/sash-banners/" }
          frontmatter: { visible: { eq: true } }
        }
        sort: { fields: [frontmatter___endDate], order: [DESC] }
      ) {
        edges {
          node {
            frontmatter {
              title
              startDate
              endDate
              href
              content
              rank
              buttonLabel
              frame {
                ...FrameModalData
              }
            }
          }
        }
      }
    }
  `)

  // Check if banners exist
  if (!data || !data.allMarkdownRemark.edges.length) {
    return null
  }

  const banners = data.allMarkdownRemark.edges
    .map(edge => edge.node.frontmatter)
    .filter(banner =>
      banner.endDate ? new Date(banner.endDate) >= new Date() : true
    )

  if (!banners.length) {
    return null
  }

  // Select the banner with the highest rank and the most recent end date
  const selectedBanner = banners.reduce((prev, current) => {
    const prevRank = prev.rank || 0
    const currentRank = current.rank || 0

    if (prevRank === currentRank) {
      return new Date(prev.endDate) > new Date(current.endDate) ? prev : current
    }
    return prevRank > currentRank ? prev : current
  })

  // If the banner points at a brand, the button opens that brand's popup
  // (the same modal used on the frames page) instead of navigating anywhere.
  const framePayload = buildFramePayload(selectedBanner.frame)

  const message = (
    <span
      className={sashBannerStyles.message}
      dangerouslySetInnerHTML={{ __html: selectedBanner.content }}
    />
  )

  return (
    <div className={sashBannerStyles.wrapper}>
      <div className={sashBannerStyles.inner}>
        {framePayload ? (
          <>
            {message}
            <button
              type="button"
              className={sashBannerStyles.button}
              onClick={() => setIsModalOpen(true)}
              aria-haspopup="dialog"
              aria-label={`Open details for ${framePayload.title}`}
            >
              {selectedBanner.buttonLabel || "Details"}
            </button>
          </>
        ) : selectedBanner.href ? (
          <a className={sashBannerStyles.link} href={selectedBanner.href}>
            {message}
          </a>
        ) : (
          message
        )}
      </div>

      {framePayload ? (
        <FrameModal
          isOpen={isModalOpen}
          frameData={framePayload}
          onRequestClose={() => setIsModalOpen(false)}
        />
      ) : null}
    </div>
  )
}

export default SashBanner
